import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { SetForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { set, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Sets", link: "/set" },
                { name: "Edit", link: "" },
                { name: set?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Set" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Set Update"}
                        bordered={true}
                    >
                        {set && (
                            <SetForm
                                set={set}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
